import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { createLabelSections, standardSections, externalFulfillmentSections } from '../../../services/other-shipping-options/constants';
import { EXTERNAL } from '../../../constants/fulfillment-types';

import EditOtherShippingOptions from './edit-component';

const mapStateToProps = (state, { fulfillmentPlanId }) => {
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }) || {};
  if (fulfillmentPlan.fulfillmentType === EXTERNAL) {
    return {
      sectionsToShow: externalFulfillmentSections,
    };
  }

  const isEmptyShipment = ['rate-browser', 'customers-create-label'].includes(fulfillmentPlanId);
  const sectionsToShow = isEmptyShipment ? createLabelSections : standardSections;

  return {
    sectionsToShow,
  };
};

export default connect(mapStateToProps)(EditOtherShippingOptions);
